export const PRODUCT_ROW_GRIDS = [10, 17, 14, 23, 36]
